/* Adds one Batidor Eléctrico Krima when the Combo para Cuidarte is in the cart.
 * The product and variant are selected in Theme settings; pricing remains in Shopify.
 */
(function () {
  'use strict';

  const gift = window.krimaComboGift;
  if (!gift || !gift.giftVariantId) return;

  const root = gift.root || '/';
  const cartUrl = root + 'cart.js';
  const addUrl = root + 'cart/add.js';
  let timer;
  let checking = false;
  let checkAgain = false;

  function scheduleCheck() {
    clearTimeout(timer);
    timer = setTimeout(checkCart, 250);
  }

  async function checkCart() {
    if (checking) {
      checkAgain = true;
      return;
    }
    checking = true;
    try {
      const cartResponse = await fetch(cartUrl, {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!cartResponse.ok) throw new Error('No se pudo consultar el carrito');
      const cart = await cartResponse.json();
      const hasCombo = cart.items.some(item => Number(item.product_id) === gift.comboProductId);
      const hasGift = cart.items.some(item => Number(item.product_id) === gift.giftProductId);
      if (!hasCombo || hasGift) return;

      const response = await fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: gift.giftVariantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('No se pudo añadir el batidor (' + response.status + ')');

      // Shapes replaces cart and drawer sections without navigating or reloading.
      document.dispatchEvent(new CustomEvent('theme:update:cart'));
    } catch (error) {
      console.warn('[Krima] Regalo del combo:', error);
    } finally {
      checking = false;
      if (checkAgain) {
        checkAgain = false;
        scheduleCheck();
      }
    }
  }

  // The Shapes theme emits this after a successful product add (including quick buy).
  document.addEventListener('shapes:cart:afteradditem', scheduleCheck);
  document.addEventListener('theme:line-item:change', scheduleCheck);
  window.addEventListener('pageshow', scheduleCheck);

  // The combo page can also navigate to /cart after a conventional form submit.
  scheduleCheck();
})();
